import React from 'react';
/* import { GoogleLogin } from 'react-google-login-component'; */
import GoogleLogin from 'react-google-login';
import SellerUser from '../../Models/SellerUser';

class GoogleLoginItem extends React.Component {

  constructor(props, context) {
    super(props, context);
  }



  render() {
    const responseGoogle = (response) => {
      console.log(response); 
      let data = {
        email: response['profileObj'].email,
        name: response['profileObj'].name,
        user_type: this.props.id
      }
      SellerUser.checkEmail(data).then(res => {
        if (parseInt(res.data.status) === 200) {
          if (res.data.payload.user_type_id === 1) {
            window.localStorage.setItem('info', JSON.stringify(res.data.payload))
            window.location.href = "/buyer-dashboard"
          } else if (res.data.payload.user_type_id === 2) {
            window.localStorage.setItem('info', JSON.stringify(res.data.payload))
            window.location.href = "/seller-dashboard"
          } else if (res.data.payload.user_type_id === 3) {
            window.localStorage.setItem('info', JSON.stringify(res.data.payload))
            window.location.href = "/affiliator-dashboard"
          }
        } else {
          alert('メールアドレスまたはパスワードが違います。')
        }
      })

    }

    return (
      <div>

        <GoogleLogin
          clientId="812854360202-69ni8ki86buf3ufk8e17a2nfkjeho7fi.apps.googleusercontent.com"
          // buttonText="Login with Google"
          render={renderProps => (
            <button onClick={renderProps.onClick} disabled={renderProps.disabled} className="social_button" >
              <img alt="" src={require("../../assets/images/Glogo2.png")} height="100%" width='100%' />
            </button>
          )}
          style={{width:'100%'}}
          onSuccess={responseGoogle}
          onFailure={responseGoogle}
          cookiePolicy={'single_host_origin'} />
      </div>
    );
  }

}

export { GoogleLoginItem };